// Generated by @placekit/uikit from icons.json. Do not edit by hand: edit icons.json,
// then run `npx uikit-icons --app .` from the app root.
// Register it once at the app root: <IconProvider icons={icons}>.

import ArrowDownCircleOutline from '@heroicons/react/24/outline/ArrowDownCircleIcon';
import ArrowLongLeftSolid from '@heroicons/react/24/solid/ArrowLongLeftIcon';
import ArrowLongRightOutline from '@heroicons/react/24/outline/ArrowLongRightIcon';
import ArrowLongRightSolid from '@heroicons/react/24/solid/ArrowLongRightIcon';
import ArrowLongRightMini from '@heroicons/react/20/solid/ArrowLongRightIcon';
import ArrowPathOutline from '@heroicons/react/24/outline/ArrowPathIcon';
import ArrowRightCircleOutline from '@heroicons/react/24/outline/ArrowRightCircleIcon';
import ArrowTopRightOnSquareOutline from '@heroicons/react/24/outline/ArrowTopRightOnSquareIcon';
import ArrowTopRightOnSquareSolid from '@heroicons/react/24/solid/ArrowTopRightOnSquareIcon';
import ArrowTopRightOnSquareMini from '@heroicons/react/20/solid/ArrowTopRightOnSquareIcon';
import ArrowTrendingUpOutline from '@heroicons/react/24/outline/ArrowTrendingUpIcon';
import ArrowUpRightOutline from '@heroicons/react/24/outline/ArrowUpRightIcon';
import ArrowUturnRightMini from '@heroicons/react/20/solid/ArrowUturnRightIcon';
import ArrowsRightLeftMini from '@heroicons/react/20/solid/ArrowsRightLeftIcon';
import AtSymbolMini from '@heroicons/react/20/solid/AtSymbolIcon';
import Bars3Solid from '@heroicons/react/24/solid/Bars3Icon';
import BellOutline from '@heroicons/react/24/outline/BellIcon';
import BoltOutline from '@heroicons/react/24/outline/BoltIcon';
import BuildingLibraryOutline from '@heroicons/react/24/outline/BuildingLibraryIcon';
import BuildingStorefrontOutline from '@heroicons/react/24/outline/BuildingStorefrontIcon';
import CalendarOutline from '@heroicons/react/24/outline/CalendarIcon';
import ChartBarOutline from '@heroicons/react/24/outline/ChartBarIcon';
import ChatBubbleLeftRightOutline from '@heroicons/react/24/outline/ChatBubbleLeftRightIcon';
import ChatBubbleOvalLeftMini from '@heroicons/react/20/solid/ChatBubbleOvalLeftIcon';
import CheckBadgeOutline from '@heroicons/react/24/outline/CheckBadgeIcon';
import CheckCircleOutline from '@heroicons/react/24/outline/CheckCircleIcon';
import ChevronDownMini from '@heroicons/react/20/solid/ChevronDownIcon';
import CodeBracketOutline from '@heroicons/react/24/outline/CodeBracketIcon';
import CodeBracketSquareOutline from '@heroicons/react/24/outline/CodeBracketSquareIcon';
import CommandLineOutline from '@heroicons/react/24/outline/CommandLineIcon';
import CubeOutline from '@heroicons/react/24/outline/CubeIcon';
import CubeTransparentOutline from '@heroicons/react/24/outline/CubeTransparentIcon';
import DocumentTextMini from '@heroicons/react/20/solid/DocumentTextIcon';
import ExclamationCircleSolid from '@heroicons/react/24/solid/ExclamationCircleIcon';
import ExclamationTriangleOutline from '@heroicons/react/24/outline/ExclamationTriangleIcon';
import EyeDropperOutline from '@heroicons/react/24/outline/EyeDropperIcon';
import FaceSmileOutline from '@heroicons/react/24/outline/FaceSmileIcon';
import FolderOutline from '@heroicons/react/24/outline/FolderIcon';
import FolderOpenOutline from '@heroicons/react/24/outline/FolderOpenIcon';
import GlobeAltOutline from '@heroicons/react/24/outline/GlobeAltIcon';
import GlobeEuropeAfricaOutline from '@heroicons/react/24/outline/GlobeEuropeAfricaIcon';
import HandThumbUpMini from '@heroicons/react/20/solid/HandThumbUpIcon';
import HeartOutline from '@heroicons/react/24/outline/HeartIcon';
import KeyOutline from '@heroicons/react/24/outline/KeyIcon';
import LanguageOutline from '@heroicons/react/24/outline/LanguageIcon';
import LanguageMini from '@heroicons/react/20/solid/LanguageIcon';
import LifebuoyOutline from '@heroicons/react/24/outline/LifebuoyIcon';
import LockClosedOutline from '@heroicons/react/24/outline/LockClosedIcon';
import LockOpenOutline from '@heroicons/react/24/outline/LockOpenIcon';
import MagnifyingGlassCircleOutline from '@heroicons/react/24/outline/MagnifyingGlassCircleIcon';
import MapOutline from '@heroicons/react/24/outline/MapIcon';
import MapPinOutline from '@heroicons/react/24/outline/MapPinIcon';
import MapPinSolid from '@heroicons/react/24/solid/MapPinIcon';
import MapPinMini from '@heroicons/react/20/solid/MapPinIcon';
import MegaphoneMini from '@heroicons/react/20/solid/MegaphoneIcon';
import PaintBrushOutline from '@heroicons/react/24/outline/PaintBrushIcon';
import PuzzlePieceOutline from '@heroicons/react/24/outline/PuzzlePieceIcon';
import ReceiptPercentOutline from '@heroicons/react/24/outline/ReceiptPercentIcon';
import ScissorsOutline from '@heroicons/react/24/outline/ScissorsIcon';
import ServerStackOutline from '@heroicons/react/24/outline/ServerStackIcon';
import ShieldCheckOutline from '@heroicons/react/24/outline/ShieldCheckIcon';
import ShoppingBagOutline from '@heroicons/react/24/outline/ShoppingBagIcon';
import SignalSolid from '@heroicons/react/24/solid/SignalIcon';
import SparklesOutline from '@heroicons/react/24/outline/SparklesIcon';
import UsersOutline from '@heroicons/react/24/outline/UsersIcon';
import UsersMini from '@heroicons/react/20/solid/UsersIcon';
import XCircleOutline from '@heroicons/react/24/outline/XCircleIcon';
import XMarkSolid from '@heroicons/react/24/solid/XMarkIcon';

export const icons = {
  'arrow-down-circle': { outline: ArrowDownCircleOutline },
  'arrow-long-left': { solid: ArrowLongLeftSolid },
  'arrow-long-right': {
    outline: ArrowLongRightOutline,
    solid: ArrowLongRightSolid,
    mini: ArrowLongRightMini,
  },
  'arrow-path': { outline: ArrowPathOutline },
  'arrow-right-circle': { outline: ArrowRightCircleOutline },
  'arrow-top-right-on-square': {
    outline: ArrowTopRightOnSquareOutline,
    solid: ArrowTopRightOnSquareSolid,
    mini: ArrowTopRightOnSquareMini,
  },
  'arrow-trending-up': { outline: ArrowTrendingUpOutline },
  'arrow-up-right': { outline: ArrowUpRightOutline },
  'arrow-uturn-right': { mini: ArrowUturnRightMini },
  'arrows-right-left': { mini: ArrowsRightLeftMini },
  'at-symbol': { mini: AtSymbolMini },
  'bars-3': { solid: Bars3Solid },
  bell: { outline: BellOutline },
  bolt: { outline: BoltOutline },
  'building-library': { outline: BuildingLibraryOutline },
  'building-storefront': { outline: BuildingStorefrontOutline },
  calendar: { outline: CalendarOutline },
  'chart-bar': { outline: ChartBarOutline },
  'chat-bubble-left-right': { outline: ChatBubbleLeftRightOutline },
  'chat-bubble-oval-left': { mini: ChatBubbleOvalLeftMini },
  'check-badge': { outline: CheckBadgeOutline },
  'check-circle': { outline: CheckCircleOutline },
  'chevron-down': { mini: ChevronDownMini },
  'code-bracket': { outline: CodeBracketOutline },
  'code-bracket-square': { outline: CodeBracketSquareOutline },
  'command-line': { outline: CommandLineOutline },
  cube: { outline: CubeOutline },
  'cube-transparent': { outline: CubeTransparentOutline },
  'document-text': { mini: DocumentTextMini },
  'exclamation-circle': { solid: ExclamationCircleSolid },
  'exclamation-triangle': { outline: ExclamationTriangleOutline },
  'eye-dropper': { outline: EyeDropperOutline },
  'face-smile': { outline: FaceSmileOutline },
  folder: { outline: FolderOutline },
  'folder-open': { outline: FolderOpenOutline },
  'globe-alt': { outline: GlobeAltOutline },
  'globe-europe-africa': { outline: GlobeEuropeAfricaOutline },
  'hand-thumb-up': { mini: HandThumbUpMini },
  heart: { outline: HeartOutline },
  key: { outline: KeyOutline },
  language: { outline: LanguageOutline, mini: LanguageMini },
  lifebuoy: { outline: LifebuoyOutline },
  'lock-closed': { outline: LockClosedOutline },
  'lock-open': { outline: LockOpenOutline },
  'magnifying-glass-circle': { outline: MagnifyingGlassCircleOutline },
  map: { outline: MapOutline },
  'map-pin': { outline: MapPinOutline, solid: MapPinSolid, mini: MapPinMini },
  megaphone: { mini: MegaphoneMini },
  'paint-brush': { outline: PaintBrushOutline },
  'puzzle-piece': { outline: PuzzlePieceOutline },
  'receipt-percent': { outline: ReceiptPercentOutline },
  scissors: { outline: ScissorsOutline },
  'server-stack': { outline: ServerStackOutline },
  'shield-check': { outline: ShieldCheckOutline },
  'shopping-bag': { outline: ShoppingBagOutline },
  signal: { solid: SignalSolid },
  sparkles: { outline: SparklesOutline },
  users: { outline: UsersOutline, mini: UsersMini },
  'x-circle': { outline: XCircleOutline },
  'x-mark': { solid: XMarkSolid },
};

export default icons;
